import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import _ from 'lodash';
import ENV from '~/__modules__/env';

export async function initI18n({
  language,
  translations,
  fallbackTranslations,
  defaultVariables,
}) {
  const ns = [
    ...(ENV.TARGET ? [`${ENV.TARGET}`, `${ENV.TARGET}_fallback`] : []),
    'default',
    'default_fallback',
  ];
  const resources = buildResources(
    translations,
    fallbackTranslations,
    ENV.TARGET,
  );

  return i18next.use(initReactI18next).init({
    lng: language,
    resources,
    ns,
    fallbackNS: ns.slice(1),
    fallbackLng: 'en_US',
    interpolation: {
      escapeValue: false,
      defaultVariables,
    },
    react: {
      useSuspense: false,
    },
    debug: process.env.NODE_ENV !== 'production',
  });
}

/*
- Input
```json
// default
{
  "lang1": {
    "key": "value",
    "ns:key": "value"
  },
  "lang2": {
    "key": "value",
    "ns:key": "value"
  }
}

// fallback
{
  "lang1": {
    "key": "value",
    "ns:key": "value"
  },
  "lang2": {
    "key": "value",
    "ns:key": "value"
  }
}
```

- Output
```json
{
  "lang1": {
    "ns": {
      "key": "value"
    },
    "ns_fallback": {
      "key": "value"
    },
    "default": {
      "key": "value"
    },
    "default_fallback": {
      "key": "value"
    },
  },
  "lang2": {
    "ns": {
      "key": "value"
    },
    "ns_fallback": {
      "key": "value"
    },
    "default": {
      "key": "value"
    },
    "default_fallback": {
      "key": "value"
    },
  }
}
```
*/
export function buildResources(translations, fallbackTranslations, namespace) {
  const res = {};
  const keyPrefix = `${namespace}:`;

  // `${namespace}`, 'default'
  for (const [lang, byKey] of Object.entries(translations)) {
    for (const [key, value] of Object.entries(byKey)) {
      const path =
        namespace && key.startsWith(keyPrefix)
          ? `${lang}.${namespace}.${key.slice(keyPrefix.length)}`
          : `${lang}.default.${key}`;
      _.set(res, path, value);
    }
  }

  // `${namespace}_fallback`, 'default_fallback'
  for (const [lang, byKey] of Object.entries(fallbackTranslations)) {
    for (const [key, value] of Object.entries(byKey)) {
      const path =
        namespace && key.startsWith(keyPrefix)
          ? `${lang}.${namespace}_fallback.${key.slice(keyPrefix.length)}`
          : `${lang}.default_fallback.${key}`;
      _.set(res, path, value);
    }
  }

  return res;
}
